import { CountEvent, CountLogDTO } from "../tsClasses/CHTypes";
import { apiPath } from "./GeneralFunc";

type AddCountEventFuncProps = {
  countEvent: CountEvent;
  userToken: string;
};

const AddCountEventFunc = async (props: AddCountEventFuncProps) => {

  const dataToSend = props.countEvent;


  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", token: props.userToken },
    body: JSON.stringify(dataToSend),
  };
  try {
    const response = await fetch(apiPath + "/addCountEvent", requestOptions);
    if (response.status == 401) {
      return "Unauthorized";
    }
    if (response == null) {
    }

    const result = await response.text();
    return result;
  } catch (error) {
    return "gotErr";
  }
};

export default AddCountEventFunc;
